
import React, { useEffect, useRef, useState, ReactNode } from 'react';

interface ScrollIndicatorWrapperProps {
  children: ReactNode;
  height: string;
}

const ScrollIndicatorWrapper: React.FC<ScrollIndicatorWrapperProps> = ({ children, height }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [showIndicator, setShowIndicator] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const container = containerRef.current;

    const checkOverflow = () => {
      if (!container) return;
      const isOverflowing = container.scrollHeight > container.clientHeight;
      setShowIndicator(isOverflowing && !hasScrolled);
    };

    const handleScroll = () => {
      if (container && container.scrollTop > 0) {
        setHasScrolled(true);
        setShowIndicator(false);
      }
    };

    checkOverflow();
    container?.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', checkOverflow);

    return () => {
      container?.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkOverflow);
    };
  }, [hasScrolled]);

  return (
    <div
      ref={containerRef}
      style={{
        maxHeight: height,
        overflowY: 'auto',
        position: 'relative',
      }}
    >
      {showIndicator && (
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            textAlign: 'center',
            background: 'linear-gradient(to top, rgb(196 193 193 / 60%), transparent)',
            padding: '10px',
            fontSize: '14px',
            pointerEvents: 'none',
            zIndex: '1021',

          }}
        >
          <span className='scroll-indicator'>
            ↓ Scroll for more
          </span>
        </div>
      )}
      {children}
    </div>
  );
};

export default ScrollIndicatorWrapper;
